import { render } from "./GpuCounter2.vue?vue&type=template&id=3a4e0b5a&scoped=true&ts=true"
import script from "./GpuCounter2.vue?vue&type=script&lang=ts"
export * from "./GpuCounter2.vue?vue&type=script&lang=ts"

import "./GpuCounter2.vue?vue&type=style&index=0&id=3a4e0b5a&scoped=true&lang=css"
import "./GpuCounter2.vue?vue&type=style&index=1&id=3a4e0b5a&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4e0b5a"]])

export default __exports__